import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { DealerType } from '@api/models';
import { LabelValue, LegacyBaseApiService, OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DealerService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/main/gnr/dealers';
	}

	public getDealer(id: string): Observable<any> {
		return this.findPageableObjects(0, 100, 'creDate,DESC', { id }).pipe(map((res) => res.content[0]));
	}

	getCurrentResponsible() {
		return this._restClientService.get(`${this.apiUrl}/search-by-current-responsible`);
	}

	public getDealersByRegionId(regionId: string): Observable<any[]> {
		const url = `${this.apiUrl}/regions/search`;
		return this._restClientService.post(url, JSON.stringify([regionId]));
	}

	public getDealersCodeList(): Observable<LabelValue<string, string>[]> {
		return this.findPageableObjects(0, 300, 'creDate,DESC', {}).pipe(
			map((res) => res.content),
			map((result) =>
				result.map((item) => ({
					label: `${item.code1} > ${item.name}`,
					value: item.code1,
				}))
			)
		);
	}
}
@Injectable()
export class DealerRegionService extends LegacyBaseApiService<any> {
	public dealerId: string;

	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/main/gnr/dealers/${this.dealerId}/regions`;
	}

	set _apiUrl(val) {}

	public getDealer(id: string): Observable<any> {
		return this.findPageableObjects(0, 100, 'creDate,DESC', { id }).pipe(map((res) => res.content[0]));
	}
}

@Injectable()
export class DealerTypeService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/dealers/types';
	}

	public findListObjects(): Observable<DealerType[]> {
		return this._restClientService.get(this.apiUrl);
	}
}
